import { render, staticRenderFns } from "./apps-roles-input.vue?vue&type=template&id=b218ceea"
import script from "./apps-roles-input.vue?vue&type=script&lang=js"
export * from "./apps-roles-input.vue?vue&type=script&lang=js"
import style0 from "./apps-roles-input.vue?vue&type=style&index=0&id=b218ceea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports